import { Usd } from "@silo/types";
import { cn } from "../../utils/class-names";
import { asWholeUsd } from "@silo/utils";
import { isNotNullable } from "effect/Predicate";

interface TotalsProps {
  className?: string;
  depositBalanceUsd: Usd | null;
  debtBalanceUsd: Usd | null;
}

export function Totals({
  className,
  depositBalanceUsd,
  debtBalanceUsd,
}: TotalsProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col sm:flex-row items-center gap-5 sm:gap-6 p-5 rounded-lg bg-shale-800 sm:py-2.5 sm:self-start",
        className
      )}
    >
      <div className="flex items-center gap-5">
        <div className="text-base text-shale-200">Total Deposited</div>

        <div
          data-cy="total-deposited"
          className="text-2xl font-medium text-white"
        >
          {isNotNullable(depositBalanceUsd)
            ? asWholeUsd(depositBalanceUsd)
            : "--"}
        </div>
      </div>

      <div className="self-stretch h-px sm:h-auto sm:w-px bg-shale-700" />

      <div className="flex items-center gap-5">
        <div className="text-base text-shale-200">Total Borrowed</div>

        <div
          data-cy="total-borrowed"
          className="text-2xl font-medium text-white"
        >
          {isNotNullable(debtBalanceUsd) ? asWholeUsd(debtBalanceUsd) : "--"}
        </div>
      </div>
    </div>
  );
}
